import clientRequestService from "../../../services/ClientRequestService";
import { METHOD_POST } from "../../../configs/Constants";
import {
  POST_DELETE_USER_PROPERTY_RESTRICTION_API,
  POST_USER_PROPERTY_RESTRICTION_API,
  POST_USER_PROPERTY_RESTRICTION_LIST_API,
} from "../configs/Endpoints";

export type UserPropertyRestriction = {
  id: number;
  user: { id: number; name: string; email: string };
  property: { id: number; name: string };
  block_hotdesk: boolean;
  block_meeting_room: boolean;
  block_day_office: boolean;
  reason: string | null;
  created_at: number | string | null;
};

export type UserPropertyRestrictionList = {
  items: UserPropertyRestriction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    last_page: number;
    next_page: number | null;
    previous_page: number | null;
  };
};

export const getRestrictionErrorMessage = (error: unknown) =>
  (error as { status?: { message?: string } })?.status?.message ||
  "Something went wrong";

export type UserPropertyRestrictionPayload = {
  property_id: number | string;
  user_id?: number;
  email?: string;
  block_hotdesk: boolean;
  block_meeting_room: boolean;
  block_day_office: boolean;
  reason?: string;
};

export const getUserPropertyRestrictionsService = async (data: {
  property_id?: number | string;
  keyword?: string;
  page?: number;
  item_per_page?: number;
}) => {
  return await clientRequestService({
    method: METHOD_POST,
    url: POST_USER_PROPERTY_RESTRICTION_LIST_API,
    data,
    isCompany: true,
  });
};

export const saveUserPropertyRestrictionService = async (
  data: UserPropertyRestrictionPayload
) => {
  return await clientRequestService({
    method: METHOD_POST,
    url: POST_USER_PROPERTY_RESTRICTION_API,
    data,
    isCompany: true,
  });
};

export const deleteUserPropertyRestrictionService = async (
  id: number | string
) => {
  return await clientRequestService({
    method: METHOD_POST,
    url: POST_DELETE_USER_PROPERTY_RESTRICTION_API.replaceAll(
      "%id%",
      String(id)
    ),
    isCompany: true,
  });
};
